import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "h-12"
}
const _hoisted_4 = { class: "max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_5 = { class: "-mt-8 sm:-mt-8 sm:flex sm:items-end sm:space-x-5" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "mt-6 sm:flex-1 sm:min-w-0 sm:flex sm:items-center sm:justify-end sm:space-x-6 sm:pb-1" }
const _hoisted_9 = { class: "sm:hidden md:block mt-6 min-w-0 flex-1" }
const _hoisted_10 = { class: "text-2xl font-bold text-gray-900 truncate" }
const _hoisted_11 = { class: "mt-4 max-w-3xl mx-auto sm:px-6 lg:px-8 overflow-x-hidden" }
const _hoisted_12 = { class: "m-2 hidden lg:block" }
const _hoisted_13 = {
  role: "list",
  class: "space-y-4 md:flex md:space-y-0 md:space-x-8"
}
const _hoisted_14 = { class: "md:flex-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "コンテンツの選択", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "md:flex-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "供養する方の情報", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "md:flex-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "データ選択", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "md:flex-1" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "お支払い", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 0,
  class: "mx-4"
}
const _hoisted_27 = {
  role: "list",
  class: "divide-y"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "grow text-sm font-medium" }
const _hoisted_30 = { class: "text-gray-900" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, null, -1)
const _hoisted_32 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "email-error"
}
const _hoisted_33 = {
  key: 1,
  class: "m-8"
}
const _hoisted_34 = { class: "mt-2" }
const _hoisted_35 = { class: "text-sm font-medium space-y-1" }
const _hoisted_36 = { class: "text-gray-900" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "mt-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, [
  /*#__PURE__*/_createTextVNode(" 俗名 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-400" }, "※俗名、または、ニックネームは必須")
], -1)
const _hoisted_40 = { class: "grid grid-cols-2 gap-y-6 gap-x-4" }
const _hoisted_41 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-600",
  role: "alert"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_43 = { class: "mt-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, " 俗名(カナ) ", -1)
const _hoisted_45 = { class: "grid grid-cols-2 gap-y-6 gap-x-4" }
const _hoisted_46 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-600",
  role: "alert"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_48 = { class: "mt-6" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, [
  /*#__PURE__*/_createTextVNode(" ニックネーム "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-400" }, "※俗名、または、ニックネームは必須")
], -1)
const _hoisted_50 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_52 = { class: "mt-6" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, " 戒名・法名 ", -1)
const _hoisted_54 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_56 = { class: "mt-6" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, " 戒名・法名(カナ) ", -1)
const _hoisted_58 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_60 = { class: "mt-6" }
const _hoisted_61 = { class: "col-span-4 flex flex-col" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "block px-2 text-sm font-medium text-gray-700" }, "生年月日", -1)
const _hoisted_63 = { class: "flex items-center" }
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<option></option><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option><option>10</option><option>11</option><option>12</option>", 13)
const _hoisted_77 = [
  _hoisted_64
]
const _hoisted_78 = /*#__PURE__*/_createStaticVNode("<option></option><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option><option>10</option><option>11</option><option>12</option><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option><option>20</option><option>21</option><option>22</option><option>23</option><option>24</option><option>25</option><option>26</option><option>27</option><option>28</option><option>29</option><option>30</option><option>31</option>", 32)
const _hoisted_110 = [
  _hoisted_78
]
const _hoisted_111 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_112 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_113 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_114 = { class: "mt-6" }
const _hoisted_115 = { class: "col-span-4 flex flex-col" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", { class: "block px-2 text-sm font-medium text-gray-700" }, "歿年月日", -1)
const _hoisted_117 = { class: "flex items-center" }
const _hoisted_118 = /*#__PURE__*/_createStaticVNode("<option></option><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option><option>10</option><option>11</option><option>12</option>", 13)
const _hoisted_131 = [
  _hoisted_118
]
const _hoisted_132 = /*#__PURE__*/_createStaticVNode("<option></option><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option><option>10</option><option>11</option><option>12</option><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option><option>20</option><option>21</option><option>22</option><option>23</option><option>24</option><option>25</option><option>26</option><option>27</option><option>28</option><option>29</option><option>30</option><option>31</option>", 32)
const _hoisted_164 = [
  _hoisted_132
]
const _hoisted_165 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_166 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_167 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_168 = { class: "mt-6" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "享年・行年", -1)
const _hoisted_170 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_171 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_172 = { class: "mt-6" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "享年・行年の選択", -1)
const _hoisted_174 = { class: "flex" }
const _hoisted_175 = { class: "relative flex items-start" }
const _hoisted_176 = { class: "flex h-5 items-center" }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3 text-sm" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "kyonen",
    class: "font-medium text-gray-700"
  }, "享年")
], -1)
const _hoisted_178 = { class: "ml-4 relative flex items-start" }
const _hoisted_179 = { class: "flex h-5 items-center" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3 text-sm" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "gyonen",
    class: "font-medium text-gray-700"
  }, "行年")
], -1)
const _hoisted_181 = { class: "mt-6" }
const _hoisted_182 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, " 喪主 ", -1)
const _hoisted_183 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_184 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_185 = {
  key: 2,
  class: "m-8"
}
const _hoisted_186 = { class: "text-sm font-medium space-y-1" }
const _hoisted_187 = { class: "text-gray-900" }
const _hoisted_188 = ["innerHTML"]
const _hoisted_189 = { class: "mt-2" }
const _hoisted_190 = { class: "mt-6" }
const _hoisted_191 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "出身地", -1)
const _hoisted_192 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_193 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_194 = { class: "mt-6" }
const _hoisted_195 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "生前の趣味", -1)
const _hoisted_196 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_197 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_198 = { class: "mt-6" }
const _hoisted_199 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "生前の学校", -1)
const _hoisted_200 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_201 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_202 = { class: "mt-6" }
const _hoisted_203 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "生前の勤務先", -1)
const _hoisted_204 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_205 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_206 = { class: "mt-6" }
const _hoisted_207 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "叙勲歴", -1)
const _hoisted_208 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_209 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_210 = {
  key: 3,
  class: "m-8"
}
const _hoisted_211 = { class: "text-sm font-medium space-y-1" }
const _hoisted_212 = { class: "text-gray-900" }
const _hoisted_213 = ["innerHTML"]
const _hoisted_214 = { class: "mt-2" }
const _hoisted_215 = { class: "mt-6" }
const _hoisted_216 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "テキストデータ", -1)
const _hoisted_217 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-400" }, "人工衛星に搭載する、故人についての思い出などを入力してください", -1)
const _hoisted_218 = {
  key: 0,
  class: "flex mt-2 p-1 mb-4 text-sm text-red-700",
  role: "alert"
}
const _hoisted_219 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_220 = {
  key: 4,
  class: "m-8"
}
const _hoisted_221 = { class: "text-sm font-medium space-y-1" }
const _hoisted_222 = { class: "text-gray-900" }
const _hoisted_223 = ["innerHTML"]
const _hoisted_224 = { class: "mt-4 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 sm:gap-x-6" }
const _hoisted_225 = ["onClick"]
const _hoisted_226 = ["src"]
const _hoisted_227 = { class: "absolute top-1 right-1 rounded-full h-8 w-8 bg-red-600 flex justify-center items-center" }
const _hoisted_228 = ["onDrop"]
const _hoisted_229 = {
  type: "button",
  class: "mt-4 relative block w-full border-2 border-gray-300 border-dashed rounded-lg p-12 text-center"
}
const _hoisted_230 = /*#__PURE__*/_createElementVNode("span", { class: "mt-2 block text-xs font-medium text-gray-600" }, " 故人の思い出の画像や動画をアップロードしてください ", -1)
const _hoisted_231 = {
  key: 5,
  class: "bg-white mx-4"
}
const _hoisted_232 = { class: "max-w-7xl mx-auto px-4 pt-4 pb-16 sm:px-6 sm:pt-8 sm:pb-24 lg:px-8 xl:px-2 xl:pt-14" }
const _hoisted_233 = { class: "max-w-lg mx-auto grid grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-2" }
const _hoisted_234 = { class: "max-w-lg mx-auto w-full" }
const _hoisted_235 = { class: "flow-root" }
const _hoisted_236 = {
  role: "list",
  class: "-my-6 divide-y divide-gray-200"
}
const _hoisted_237 = { class: "py-6 flex space-x-6" }
const _hoisted_238 = { class: "flex-auto" }
const _hoisted_239 = { class: "space-y-1 mb-4 sm:flex sm:items-start sm:justify-between sm:space-x-6" }
const _hoisted_240 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_241 = { class: "text-gray-900" }
const _hoisted_242 = ["innerHTML"]
const _hoisted_243 = {
  key: 0,
  class: "space-y-1 mt-2 sm:flex sm:items-start sm:justify-between sm:space-x-6"
}
const _hoisted_244 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_245 = { class: "text-gray-900" }
const _hoisted_246 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-400" }, "俗名", -1)
const _hoisted_247 = { key: 0 }
const _hoisted_248 = {
  key: 1,
  class: "space-y-1 mt-2 sm:flex sm:items-start sm:justify-between sm:space-x-6"
}
const _hoisted_249 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_250 = { class: "text-gray-900" }
const _hoisted_251 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-400" }, "ニックネーム", -1)
const _hoisted_252 = {
  key: 2,
  class: "space-y-1 mt-2 sm:flex sm:items-start sm:justify-between sm:space-x-6"
}
const _hoisted_253 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_254 = { class: "text-gray-900" }
const _hoisted_255 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-400" }, "法名・戒名", -1)
const _hoisted_256 = {
  key: 3,
  class: "space-y-1 mt-2 sm:flex sm:items-start sm:justify-between sm:space-x-6"
}
const _hoisted_257 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_258 = { class: "text-gray-900" }
const _hoisted_259 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-400" }, "生年月日", -1)
const _hoisted_260 = {
  key: 4,
  class: "space-y-1 mt-2 sm:flex sm:items-start sm:justify-between sm:space-x-6"
}
const _hoisted_261 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_262 = { class: "text-gray-900" }
const _hoisted_263 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-400" }, "歿年月日", -1)
const _hoisted_264 = {
  key: 5,
  class: "space-y-1 mt-2 sm:flex sm:items-start sm:justify-between sm:space-x-6"
}
const _hoisted_265 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_266 = { class: "text-gray-900" }
const _hoisted_267 = { class: "text-gray-400" }
const _hoisted_268 = {
  key: 6,
  class: "space-y-1 mt-2 sm:flex sm:items-start sm:justify-between sm:space-x-6"
}
const _hoisted_269 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_270 = { class: "text-gray-900" }
const _hoisted_271 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-400" }, "喪主", -1)
const _hoisted_272 = {
  key: 7,
  class: "space-y-1 mt-2 sm:flex sm:items-start sm:justify-between sm:space-x-6"
}
const _hoisted_273 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_274 = { class: "text-gray-900" }
const _hoisted_275 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-400" }, "出身地", -1)
const _hoisted_276 = {
  key: 8,
  class: "space-y-1 mt-2 sm:flex sm:items-start sm:justify-between sm:space-x-6"
}
const _hoisted_277 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_278 = { class: "text-gray-900" }
const _hoisted_279 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-400" }, "生前の趣味", -1)
const _hoisted_280 = {
  key: 9,
  class: "space-y-1 mt-2 sm:flex sm:items-start sm:justify-between sm:space-x-6"
}
const _hoisted_281 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_282 = { class: "text-gray-900" }
const _hoisted_283 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-400" }, "生前の学校", -1)
const _hoisted_284 = {
  key: 10,
  class: "space-y-1 mt-2 sm:flex sm:items-start sm:justify-between sm:space-x-6"
}
const _hoisted_285 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_286 = { class: "text-gray-900" }
const _hoisted_287 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-400" }, "生前の勤務先", -1)
const _hoisted_288 = {
  key: 11,
  class: "space-y-1 mt-2 sm:flex sm:items-start sm:justify-between sm:space-x-6"
}
const _hoisted_289 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_290 = { class: "text-gray-900" }
const _hoisted_291 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-400" }, "叙勲歴", -1)
const _hoisted_292 = {
  key: 0,
  class: "mt-4 scrolling-touch items-start"
}
const _hoisted_293 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-gray-400" }, "テキストデータ", -1)
const _hoisted_294 = ["innerHTML"]
const _hoisted_295 = { class: "mt-4 overflow-x-scroll scrolling-touch items-start" }
const _hoisted_296 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-gray-400" }, "搭載データ", -1)
const _hoisted_297 = { class: "flex flex-nowrap" }
const _hoisted_298 = ["src"]
const _hoisted_299 = { class: "text-sm font-medium text-gray-500 mt-10 space-y-6" }
const _hoisted_300 = { class: "flex justify-between border-t border-gray-200 text-gray-900 pt-6" }
const _hoisted_301 = /*#__PURE__*/_createElementVNode("dt", { class: "text-base" }, "お支払い金額", -1)
const _hoisted_302 = { class: "text-base" }
const _hoisted_303 = { class: "max-w-lg mx-auto w-full" }
const _hoisted_304 = { class: "mt-6" }
const _hoisted_305 = { class: "mt-6" }
const _hoisted_306 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "email-error"
}
const _hoisted_307 = { class: "mx-4 my-8 flex justify-end" }
const _hoisted_308 = ["onClick"]
const _hoisted_309 = ["onClick"]

import { loadStripe, Stripe, StripeElements } from "@stripe/stripe-js";

import { computed, onBeforeMount, onMounted, ref } from "vue";

import * as yup from "yup";
import { useField, useForm, FieldContext } from "vee-validate";

import Temple from "@/models/Temple";
import Menu from "@/models/Menu";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import { Auth, Storage } from "aws-amplify";
import { uuid } from "vue-uuid";
import axios from "axios";

// import {
//   PlusIcon,
//   PhoneIcon,
//   LocationMarkerIcon,
//   GlobeIcon,
// } from "@heroicons/vue/solid";

// import { Auth, Storage } from "aws-amplify";
// import { uuid } from "vue-uuid";

import AppHeader from "@/components/AppHeader.vue";
// import Temple from "../models/Temple";
// import Menu from "../models/Menu";
// import { MediaResource } from "../models/MediaResource";
// import axios from "axios";
// import ValidationUtil from "@/utils/ValidationUtil";
// import { computed } from "vue";

// @Options({
//   components: {
//     PlusIcon,
//     PhoneIcon,
//     LocationMarkerIcon,
//     GlobeIcon,
//     AppHeader,
//   },
// })
// export default class InputPrayView extends Vue {

const publisher_key =
  "pk_live_51KUPkkBvZuQJtNEWTWFOlP47fwXaRAajHBJeBRg7lfFDv82XCFLdmR7qe17br6I83FeZjZrOgXdAlwQOiBkLQ9Tj00ZkybZsy5";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputPrayView',
  setup(__props) {

// import { Options, Vue } from "vue-class-component";
const store = useStore();
const route = useRoute();
const router = useRouter();

const temple_id = ref<string>("");
const temple = ref<Temple>({} as Temple);
const menus = ref<Menu[]>([]);

const formSchema = yup.object({
  selfie_image_url: yup.string(),
  family_name: yup.string().test("required", "俗名かニックネームを入力してください", (value): boolean => {
    return (!!family_name.value && !!given_name.value) || !!nickname.value;
  }),
  given_name: yup.string(),
  family_name_kana: yup.string().kana(),
  given_name_kana: yup.string().kana(),
  nickname: yup.string(),
  buddist_name: yup.string(),
  buddist_name_kana: yup.string().kana(),
  date_of_birth_year: yup.string(),
  date_of_birth_month: yup.string(),
  date_of_birth_day: yup.string(),
  date_of_dead_year: yup.string(),
  date_of_dead_month: yup.string(),
  date_of_dead_day: yup.string(),
  age: yup.string(),
  chief_mourner: yup.string(),
  birthplace: yup.string(),
  hobby: yup.string(),
  school: yup.string(),
  job: yup.string(),
  conferment: yup.string(),
  text: yup.string(),
});

useForm({ validationSchema: formSchema });

const selfie_image_url_field = useField<string>("main_image_url");
const family_name_field = useField<string>("family_name");
const given_name_field = useField<string>("given_name");
const family_name_kana_field = useField<string>("family_name_kana");
const given_name_kana_field = useField<string>("given_name_kana");
const nickname_field = useField<string>("nickname");
const buddist_name_field = useField<string>("buddist_name");
const buddist_name_kana_field = useField<string>("buddist_name_kana");
const date_of_birth_year_field = useField<string>("date_of_birth_year");
const date_of_birth_month_field = useField<string>("date_of_birth_month");
const date_of_birth_day_field = useField<string>("date_of_birth_day");
const date_of_dead_year_field = useField<string>("date_of_dead_year");
const date_of_dead_month_field = useField<string>("date_of_dead_month");
const date_of_dead_day_field = useField<string>("date_of_dead_day");
const age_field = useField<string>("age");
const chief_mourner_field = useField<string>("chief_mourner");
const birthplace_field = useField<string>("birthplace");
const hobby_field = useField<string>("hobby");
const school_field = useField<string>("school");
const job_field = useField<string>("job");
const conferment_field = useField<string>("conferment");
const text_field = useField<string>("text");

//     return {
const selfie_image_url = selfie_image_url_field.value;
const selfie_image_url_error = selfie_image_url_field.errorMessage;

const family_name = family_name_field.value;
const family_name_error = family_name_field.errorMessage;

const given_name = given_name_field.value;
const given_name_error = given_name_field.errorMessage;

const family_name_kana = family_name_kana_field.value;
const family_name_kana_error = family_name_kana_field.errorMessage;

const given_name_kana = given_name_kana_field.value;
const given_name_kana_error = given_name_kana_field.errorMessage;

const nickname = nickname_field.value;
const nickname_error = nickname_field.errorMessage;

const buddist_name = buddist_name_field.value;
const buddist_name_error = buddist_name_field.errorMessage;

const buddist_name_kana = buddist_name_kana_field.value;
const buddist_name_kana_error = buddist_name_kana_field.errorMessage;

const date_of_birth_year = date_of_birth_year_field.value;
const date_of_birth_year_error = date_of_birth_year_field.errorMessage;

const date_of_birth_month = date_of_birth_month_field.value;
const date_of_birth_month_error = date_of_birth_month_field.errorMessage;

const date_of_birth_day = date_of_birth_day_field.value;
const date_of_birth_day_error = date_of_birth_day_field.errorMessage;

const date_of_birth_error = computed<string>(() => {
  if (date_of_birth_year_error.value) {
    return date_of_birth_year_error.value;
  }
  if (date_of_birth_year_error.value) {
    return date_of_birth_year_error.value;
  }
  if (date_of_birth_year_error.value) {
    return date_of_birth_year_error.value;
  }
  return "";
});

const date_of_dead_year = date_of_dead_year_field.value;
const date_of_dead_year_error = date_of_dead_year_field.errorMessage;

const date_of_dead_month = date_of_dead_month_field.value;
const date_of_dead_month_error = date_of_dead_month_field.errorMessage;

const date_of_dead_day = date_of_dead_day_field.value;
const date_of_dead_day_error = date_of_dead_day_field.errorMessage;

const date_of_dead_error = computed<string>(() => {
  if (date_of_dead_year_error.value) {
    return date_of_dead_year_error.value;
  }
  if (date_of_dead_year_error.value) {
    return date_of_dead_year_error.value;
  }
  if (date_of_dead_year_error.value) {
    return date_of_dead_year_error.value;
  }
  return "";
});

const age = age_field.value;
const age_error = age_field.errorMessage;

const age_of_dead_type = ref<string>('kyonen');

const chief_mourner = chief_mourner_field.value;
const chief_mourner_error = chief_mourner_field.errorMessage;

const birthplace = birthplace_field.value;
const birthplace_error = birthplace_field.errorMessage;

const hobby = hobby_field.value;
const hobby_error = hobby_field.errorMessage;

const school = school_field.value;
const school_error = school_field.errorMessage;

const job = job_field.value;
const job_error = job_field.errorMessage;

const conferment = conferment_field.value;
const conferment_error = conferment_field.errorMessage;

const text = text_field.value;
const text_error = text_field.errorMessage;

const text_v = computed<string>(() => {
  if (!text.value) {
    return "";
  }

  return text.value.replace(/\n/g, "<br />");
});

const resource_urls = ref<string[]>([]);

const step = ref<string>("select_menu");

// const publisher_key =
//   "pk_test_51KUPkkBvZuQJtNEW1ltcwY2dZtsTtzZHiUCVnJQiunJTXh284TGn5CIHIbkjXtU8GHReZdQVoaiQGUo2Hb6YqED6004X2uWhuS";
let stripe: Stripe | null = null;
let stripeElements: StripeElements | null = null;

const error_message = ref<string>("");

const selected_menu = computed<Menu | null>(() => {
  return menus.value.find((check) => check.is_selected) as Menu | null;
});

const price = computed<number | null>(() => {
  if (!selected_menu.value) {
    return null;
  }

  return selected_menu.value.temple_prices[temple_id.value] as number | null;
});

const date_of_birth = computed<string>(() => {
  if (
    !date_of_birth_year.value ||
    !date_of_birth_month.value ||
    !date_of_birth_day.value
  ) {
    return "";
  }

  return `${date_of_birth_year.value}年${date_of_birth_month.value}月${date_of_birth_day.value}`;
});

const date_of_dead = computed<string>(() => {
  if (
    !date_of_dead_year.value ||
    !date_of_dead_month.value ||
    !date_of_dead_day.value
  ) {
    return "";
  }

  return `${date_of_dead_year.value}年${date_of_dead_month.value}月${date_of_dead_day.value}`;
});

const refresh = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      temple.value = await Temple.get(temple_id.value);
      const result = await Menu.searchByTemple(temple_id.value);

      result.menus.forEach((menu) => {
        if (menu.menu_type !== "for_dead") {
          return;
        }
        menus.value.push(menu);
      });
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const clearInput = () => {
  selfie_image_url.value = "";
  family_name.value = "";
  given_name.value = "";
  family_name_kana.value = "";
  given_name_kana.value = "";
  nickname.value = "";
  buddist_name.value = "";
  buddist_name_kana.value = "";
  date_of_birth_year.value = "";
  date_of_birth_month.value = "";
  date_of_birth_day.value = "";
  date_of_dead_year.value = "";
  date_of_dead_month.value = "";
  date_of_dead_day.value = "";
  age.value = "";
  age_of_dead_type.value = "kyonen";
  chief_mourner.value = "";
  birthplace.value = "";
  hobby.value = "";
  school.value = "";
  job.value = "";
  conferment.value = "";
  text.value = "";
  resource_urls.value.length = 0;
};

const onSelectionChanged = (menu: Menu) => {
  menus.value.forEach((check) => {
    check.is_selected = check == menu;
  });

  // console.log(selected_menu);
};

const upload_file = ref<HTMLInputElement>();
const selectFile = () => {
  const element = upload_file.value;
  element?.click();
};

const onUploadFileChanged = (e: Event) => {
  const element = e.target as HTMLInputElement;

  if (!element.files) {
    return;
  }

  const file = element.files[0];

  element.value = "";

  uploadImage(file);
};

const onImageDropped = (e: DragEvent) => {
  // console.log(e);
  e.preventDefault();

  // console.log("1");
  if (!e.dataTransfer?.files.length) {
    return;
  }

  // console.log("2");
  const file = e.dataTransfer?.files[0];

  uploadImage(file);
};

const uploadImage = (file: File) => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      // console.log(file);

      const split = file.name.split(".");
      const filename = uuid.v4();
      const extension = split[split.length - 1];
      const contentType = extension == "png" ? "image/png" : "image/jpg";

      Storage.configure({ customPrefix: { public: "orders" } });
      const s3response = await Storage.put(`/${filename}.${extension}`, file, {
        contentType: contentType,
      });

      // console.log(s3response);

      resource_urls.value.push(
        `${process.env.VUE_APP_HOST}/orders/${filename}.${extension}`
      );
      // console.log(resource_urls);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const removeResource = (url: string) => {
  resource_urls.value.splice(resource_urls.value.indexOf(url), 1);
};

const previous_step = computed<string>(() => {
  if(step.value == 'confirm') {
    if (
      selected_menu?.value?.accept_photo ||
      selected_menu?.value?.accept_video
    ) {
      return "input_media";
    } else if(selected_menu?.value?.accept_text) {
      return "input_text";
    }
    return "input_advance";
  } else if (step.value == "input_media") {
    if(selected_menu?.value?.accept_text) {
      return "input_text";
    }
    return "input_advance";
  } else if (step.value == "input_text") {
    return "input_advance";
  } else if (step.value == "input_advance") {
    return "input_basic";
  }

  return "select_menu";
});

const previous = () => {
  const p = previous_step.value;
  if(p == 'select_menu') {
    clearInput();
  }
  step.value = p;
};

const next_step = computed<string>(() => {
  if (step.value == "select_menu") {
    return "input_basic";
  } else if (step.value == "input_basic") {
    return "input_advance";
  } else if (step.value == "input_advance") {
    if (selected_menu?.value?.accept_text) {
      return "input_text";
    } else if (
      selected_menu?.value?.accept_photo ||
      selected_menu?.value?.accept_video
    ) {
      return "input_media";
    }
    return "confirm";
  } else if (step.value == "input_text") {
    if (
      selected_menu?.value?.accept_photo ||
      selected_menu?.value?.accept_video
    ) {
      return "input_media";
    }
    return "confirm";
  } else if (step.value == "input_media") {
    return "confirm";
  }

  return "payment";
});

const next_step_label = computed<string>(() => {
  switch (next_step.value) {
    case "input_basic":
    case "input_advance":
      return "故人の情報入力";
    case "input_text":
      return "テキストデータ入力";
    case "input_media":
      return "搭載データ入力";
    case "confirm":
      return "申込内容の確認";
    case "payment":
      return "お支払い";
    default:
      return "";
  }
});

const next = async () => {
  if (step.value == "select_menu") {
    const valid1 = await validateSelectionMenu();
    if (!valid1) {
      return;
    }

    step.value = next_step.value;
  } else if (step.value == "input_basic") {
    const valid2 = await validateBasic();
    if (!valid2) {
      return;
    }
    step.value = next_step.value;
  } else if (step.value == "input_advance") {
    const valid2 = await validateAdvance();
    if (!valid2) {
      return;
    }
    step.value = next_step.value;
  } else if (step.value == "input_text") {
    const valid2 = await validateAdvance();
    if (!valid2) {
      return;
    }
    step.value = next_step.value;
  } else if (step.value == "input_media") {
    const valid2 = await validateAdvance();
    if (!valid2) {
      return;
    }
    step.value = next_step.value;
  } else if (step.value == "confirm") {
    step.value = next_step.value;
    createPaymentSheet();
  } else if (step.value == "payment") {
    doPayment();
  }
};

const onSelectedMenu = (menu: Menu) => {
  console.log(`onSelectedMenu(${menu.name})`);
  menu.is_selected = true;
  next();
};

const validateSelectionMenu = async (): Promise<boolean> => {
  return selected_menu.value != null;
};

const validateBasic = async (): Promise<boolean> => {
  await selfie_image_url_field.validate();
  await family_name_field.validate();
  await given_name_field.validate();
  await family_name_kana_field.validate();
  await given_name_kana_field.validate();
  await nickname_field.validate();
  await buddist_name_field.validate();
  await buddist_name_kana_field.validate();
  await date_of_birth_year_field.validate();
  await date_of_birth_month_field.validate();
  await date_of_birth_day_field.validate();
  await date_of_dead_year_field.validate();
  await date_of_dead_month_field.validate();
  await date_of_dead_day_field.validate();
  await age_field.validate();
  await chief_mourner_field.validate();

  return (
    !selfie_image_url_error.value &&
    !family_name_error.value &&
    !given_name_error.value &&
    !family_name_kana_error.value &&
    !given_name_kana_error.value &&
    !nickname_error.value &&
    !buddist_name_error.value &&
    !buddist_name_kana_error.value &&
    !date_of_birth_year_error.value &&
    !date_of_birth_month_error.value &&
    !date_of_birth_day_error.value &&
    !date_of_dead_year_error.value &&
    !date_of_dead_month_error.value &&
    !date_of_dead_day_error.value &&
    !age_error.value &&
    !chief_mourner_error.value
  );
};

const validateAdvance = async (): Promise<boolean> => {
  await birthplace_field.validate();
  await hobby_field.validate();
  await school_field.validate();
  await job_field.validate();
  await conferment_field.validate();

  return (
    !birthplace_error.value &&
    !hobby_error.value &&
    !school_error.value &&
    !job_error.value &&
    !conferment_error.value
  );
};

const validateText = async (): Promise<boolean> => {
  await text_field.validate();

  return !text_error.value;
};

const payment = ref<HTMLDivElement>();

const createPaymentSheet = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const cognitoUser = await Auth.currentUserInfo();
      const id = cognitoUser.attributes.sub;
      const param = {
        customer_id: id,
        temple_id: temple_id.value,
        menu_id: selected_menu.value?.id,
        applyment_method: "app",
        attributes: {
          family_name: family_name.value,
          given_name: given_name.value,
          family_name_kana: family_name_kana.value,
          given_name_kana: given_name_kana.value,
          nickname: nickname.value,
          date_of_birth: date_of_birth.value,
          buddist_name: buddist_name.value,
          buddist_name_kana: buddist_name_kana.value,
          date_of_dead: date_of_dead.value,
          age: age.value,
          age_of_dead_type: age_of_dead_type.value,
          chief_mourner_name: chief_mourner.value,
          birthplace: birthplace.value,
          hobby: hobby.value,
          school: school.value,
          job: job.value,
          conferment: conferment.value,
        },
        media_urls: resource_urls.value,
      };

      // console.log(param);

      const user = await Auth.currentAuthenticatedUser();
      const config = {
        headers: {
          Authorization: `${user.signInUserSession.idToken.jwtToken}}`,
        },
      };
      const response = await axios.post(
        `${process.env.VUE_APP_API_HOST}/orders`,
        param,
        config
      );
      // console.log(response);
      const secret = response.data.data.payment_intent as string;
      stripeElements = stripe!.elements({
        clientSecret: secret,
      });
      // const cardElement = elements.create("card");
      // const cardHost = $refs.card as HTMLDivElement;
      // cardElement.mount(cardHost);
      const paymentElement = stripeElements.create("payment");
      const paymentHost = payment.value as HTMLDivElement;
      paymentElement.mount(paymentHost!);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const doPayment = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const { error } = await stripe!.confirmPayment({
        elements: stripeElements!,
        redirect: "if_required",
      });

      // console.log(error);

      if (error) {
        error_message.value = error.message!;
        return;
      }

      router.replace("/me/orders");
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

onBeforeMount(async () => {
  stripe = await loadStripe(publisher_key);
});

onMounted(() => {
  temple_id.value = route.params.temple_id as string;
  refresh();
});

return (_ctx: any,_cache: any) => {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader),
    _createElementVNode("div", null, [
      (temple.value.main_image_url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              class: "h-24 w-full object-cover lg:h-24",
              src: temple.value.main_image_url ?? require('@/assets/images/empty.png'),
              alt: ""
            }, null, 8, _hoisted_2)
          ]))
        : _createCommentVNode("", true),
      (!temple.value.main_image_url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (temple.value.selfie_image_url)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "h-16 w-16 rounded-full ring-4 ring-white bg-white sm:h-16 sm:w-16",
                  src: 
              temple.value.selfie_image_url ?? require('@/assets/images/empty.png')
            ,
                  alt: ""
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h1", _hoisted_10, _toDisplayString(temple.value.name) + " 宇宙供養のお申し込み ", 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("nav", _hoisted_12, [
        _createElementVNode("ol", _hoisted_13, [
          _createElementVNode("li", _hoisted_14, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["group pl-4 py-2 flex flex-col border-l-4 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4", {
              'border-stone-600 hover:border-stone-800':
                step.value == 'select_menu' || step.value == 'input_basic' || step.value == 'input_advance',
            }])
            }, _hoisted_16, 2)
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["pl-4 py-2 flex flex-col border-l-4 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4", {
              'border-stone-600 hover:border-stone-800':
                step.value == 'select_menu' || step.value == 'input_basic' || step.value == 'input_advance',
            }]),
              "aria-current": "step"
            }, _hoisted_19, 2)
          ]),
          _createElementVNode("li", _hoisted_20, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["pl-4 py-2 flex flex-col border-l-4 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4", {
              'border-stone-600 hover:border-stone-800':
                step.value == 'select_menu' ||
                step.value == 'input_basic' ||
                step.value == 'input_advance' ||
                step.value == 'step4',
            }]),
              "aria-current": "step"
            }, _hoisted_22, 2)
          ]),
          _createElementVNode("li", _hoisted_23, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["pl-4 py-2 flex flex-col border-l-4 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4", {
              'border-stone-600 hover:border-stone-800':
                step.value == 'select_menu' ||
                step.value == 'input_basic' ||
                step.value == 'input_advance' ||
                step.value == 'step4' ||
                step.value == 'step5',
            }]),
              "aria-current": "step"
            }, _hoisted_25, 2)
          ])
        ])
      ]),
      (step.value == 'select_menu')
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("ul", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menus.value, (menu) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: menu.id,
                  class: "flex p-6 mb-4 space-x-6 bg-white justify-streatch items-center cursor-pointer",
                  onClick: ($event: any) => (onSelectedMenu(menu))
                }, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("h3", _hoisted_30, _toDisplayString(menu.name), 1)
                  ]),
                  _hoisted_31,
                  _createVNode(_component_fa, {
                    icon: "angle-right",
                    class: "text-gray-400"
                  })
                ], 8, _hoisted_28))
              }), 128))
            ]),
            (!!error_message.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(error_message.value), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (step.value == 'input_basic')
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("h3", _hoisted_36, _toDisplayString(selected_menu.value?.name), 1),
                _createElementVNode("p", {
                  class: "text-gray-500",
                  innerHTML: selected_menu.value?.description
                }, null, 8, _hoisted_37)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md col-span-1", { 'border-red-200': _unref(family_name_error) }]),
                    placeholder: "俗名(苗字)",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(family_name) ? (family_name).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(family_name)]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md col-span-1", { 'border-red-200': _unref(given_name_error) }]),
                    placeholder: "俗名(名前)",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(given_name) ? (given_name).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(given_name)]
                  ])
                ]),
                (_unref(family_name_error) || _unref(given_name_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", null, _toDisplayString(_unref(family_name_error) || _unref(given_name_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md col-span-1", { 'border-red-200': _unref(family_name_kana_error) }]),
                    placeholder: "俗名(名字カナ)",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(family_name_kana) ? (family_name_kana).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(family_name_kana)]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md col-span-1", { 'border-red-200': _unref(given_name_kana_error) }]),
                    placeholder: "俗名(名前カナ)",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(given_name_kana) ? (given_name_kana).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(given_name_kana)]
                  ])
                ]),
                (_unref(family_name_kana_error) || _unref(given_name_kana_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("div", null, _toDisplayString(_unref(family_name_kana_error) || _unref(given_name_kana_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(nickname_error) }]),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(nickname) ? (nickname).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(nickname)]
                  ])
                ]),
                (_unref(nickname_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _hoisted_51,
                      _createElementVNode("div", null, _toDisplayString(_unref(nickname_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(buddist_name_error) }]),
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(buddist_name) ? (buddist_name).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(buddist_name)]
                  ])
                ]),
                (_unref(buddist_name_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("div", null, _toDisplayString(_unref(buddist_name_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(buddist_name_kana_error) }]),
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(buddist_name_kana) ? (buddist_name_kana).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(buddist_name_kana)]
                  ])
                ]),
                (_unref(buddist_name_kana_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", null, _toDisplayString(_unref(buddist_name_kana_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createTextVNode(_toDisplayString(date_of_birth_error.value) + " ", 1),
                _createElementVNode("div", _hoisted_61, [
                  _hoisted_62,
                  _createElementVNode("div", _hoisted_63, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["block w-24 px-2 pt-1 pb-2 mt-1 placeholder-gray-400 border-b appearance-none focus:outline-none", {
                  'border-gray-300': !date_of_birth_error.value,
                  'border-red-300': !!date_of_birth_error.value,
                }]),
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(date_of_birth_year) ? (date_of_birth_year).value = $event : null))
                    }, null, 2), [
                      [_vModelText, _unref(date_of_birth_year)]
                    ]),
                    _createTextVNode(" 年 "),
                    _withDirectives(_createElementVNode("select", {
                      class: _normalizeClass(["block w-16 px-2 pt-1 pb-2 ml-2 mt-1 placeholder-gray-400 border-b appearance-none focus:outline-none", {
                  'border-gray-300': !date_of_birth_error.value,
                  'border-red-300': !!date_of_birth_error.value,
                }]),
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(date_of_birth_month) ? (date_of_birth_month).value = $event : null))
                    }, _hoisted_77, 2), [
                      [_vModelSelect, _unref(date_of_birth_month)]
                    ]),
                    _createTextVNode(" 月 "),
                    _withDirectives(_createElementVNode("select", {
                      class: _normalizeClass(["block w-16 px-2 pt-1 pb-2 ml-2 mt-1 placeholder-gray-400 border-b appearance-none focus:outline-none", {
                  'border-gray-300': !date_of_birth_error.value,
                  'border-red-300': !!date_of_birth_error.value,
                }]),
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(date_of_birth_day) ? (date_of_birth_day).value = $event : null))
                    }, _hoisted_110, 2), [
                      [_vModelSelect, _unref(date_of_birth_day)]
                    ]),
                    _createTextVNode(" 日 ")
                  ]),
                  (!date_of_birth_error.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_111, "例) 1952 昭和25 BC100"))
                    : _createCommentVNode("", true)
                ]),
                (date_of_birth_error.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                      _hoisted_113,
                      _createElementVNode("div", null, _toDisplayString(date_of_birth_error.value), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("div", _hoisted_115, [
                  _hoisted_116,
                  _createElementVNode("div", _hoisted_117, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["block w-24 px-2 pt-1 pb-2 mt-1 placeholder-gray-400 border-b appearance-none focus:outline-none", {
                  'border-gray-300': !date_of_dead_error.value,
                  'border-red-300': !!date_of_dead_error.value,
                }]),
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(date_of_dead_year) ? (date_of_dead_year).value = $event : null))
                    }, null, 2), [
                      [_vModelText, _unref(date_of_dead_year)]
                    ]),
                    _createTextVNode(" 年 "),
                    _withDirectives(_createElementVNode("select", {
                      class: _normalizeClass(["block w-16 px-2 pt-1 pb-2 ml-2 mt-1 placeholder-gray-400 border-b appearance-none focus:outline-none", {
                  'border-gray-300': !date_of_dead_error.value,
                  'border-red-300': !!date_of_dead_error.value,
                }]),
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(date_of_dead_month) ? (date_of_dead_month).value = $event : null))
                    }, _hoisted_131, 2), [
                      [_vModelSelect, _unref(date_of_dead_month)]
                    ]),
                    _createTextVNode(" 月 "),
                    _withDirectives(_createElementVNode("select", {
                      class: _normalizeClass(["block w-16 px-2 pt-1 pb-2 ml-2 mt-1 placeholder-gray-400 border-b appearance-none focus:outline-none", {
                  'border-gray-300': !date_of_dead_error.value,
                  'border-red-300': !!date_of_dead_error.value,
                }]),
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(date_of_dead_day) ? (date_of_dead_day).value = $event : null))
                    }, _hoisted_164, 2), [
                      [_vModelSelect, _unref(date_of_dead_day)]
                    ]),
                    _createTextVNode(" 日 ")
                  ]),
                  (!date_of_dead_error.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_165, "例) 1952 昭和25 BC100"))
                    : _createCommentVNode("", true)
                ]),
                (date_of_dead_error.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                      _hoisted_167,
                      _createElementVNode("div", null, _toDisplayString(date_of_dead_error.value), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_168, [
                _hoisted_169,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(age_error) }]),
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(age) ? (age).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(age)]
                  ])
                ]),
                (_unref(age_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                      _hoisted_171,
                      _createElementVNode("div", null, _toDisplayString(_unref(age_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_172, [
                _hoisted_173,
                _createElementVNode("div", _hoisted_174, [
                  _createElementVNode("div", _hoisted_175, [
                    _createElementVNode("div", _hoisted_176, [
                      _withDirectives(_createElementVNode("input", {
                        id: "kyonen",
                        type: "radio",
                        class: "h-4 w-4 rounded border-gray-300 text-gray-600",
                        value: "kyonen",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((age_of_dead_type).value = $event))
                      }, null, 512), [
                        [_vModelRadio, age_of_dead_type.value]
                      ])
                    ]),
                    _hoisted_177
                  ]),
                  _createElementVNode("div", _hoisted_178, [
                    _createElementVNode("div", _hoisted_179, [
                      _withDirectives(_createElementVNode("input", {
                        id: "gyonen",
                        type: "radio",
                        class: "h-4 w-4 rounded border-gray-300 text-gray-600",
                        value: "gyonen",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((age_of_dead_type).value = $event))
                      }, null, 512), [
                        [_vModelRadio, age_of_dead_type.value]
                      ])
                    ]),
                    _hoisted_180
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_181, [
                _hoisted_182,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(chief_mourner_error) }]),
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(chief_mourner) ? (chief_mourner).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(chief_mourner)]
                  ])
                ]),
                (_unref(chief_mourner_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                      _hoisted_184,
                      _createElementVNode("div", null, _toDisplayString(_unref(chief_mourner_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (step.value == 'input_advance')
        ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
            _createElementVNode("div", _hoisted_186, [
              _createElementVNode("h3", _hoisted_187, _toDisplayString(selected_menu.value?.name), 1),
              _createElementVNode("p", {
                class: "text-gray-500",
                innerHTML: selected_menu.value?.description
              }, null, 8, _hoisted_188)
            ]),
            _createElementVNode("div", _hoisted_189, [
              _createElementVNode("div", _hoisted_190, [
                _hoisted_191,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(birthplace_error) }]),
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(birthplace) ? (birthplace).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(birthplace)]
                  ])
                ]),
                (_unref(birthplace_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_192, [
                      _hoisted_193,
                      _createElementVNode("div", null, _toDisplayString(_unref(birthplace_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_194, [
                _hoisted_195,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(hobby_error) }]),
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(hobby) ? (hobby).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(hobby)]
                  ])
                ]),
                (_unref(hobby_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
                      _hoisted_197,
                      _createElementVNode("div", null, _toDisplayString(_unref(hobby_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_198, [
                _hoisted_199,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(school_error) }]),
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(school) ? (school).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(school)]
                  ])
                ]),
                (_unref(school_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
                      _hoisted_201,
                      _createElementVNode("div", null, _toDisplayString(_unref(school_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_202, [
                _hoisted_203,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(job_error) }]),
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_isRef(job) ? (job).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(job)]
                  ])
                ]),
                (_unref(job_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                      _hoisted_205,
                      _createElementVNode("div", null, _toDisplayString(_unref(job_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_206, [
                _hoisted_207,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(conferment_error) }]),
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_isRef(conferment) ? (conferment).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(conferment)]
                  ])
                ]),
                (_unref(conferment_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                      _hoisted_209,
                      _createElementVNode("div", null, _toDisplayString(_unref(conferment_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (step.value == 'input_text')
        ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
            _createElementVNode("div", _hoisted_211, [
              _createElementVNode("h3", _hoisted_212, _toDisplayString(selected_menu.value?.name), 1),
              _createElementVNode("p", {
                class: "text-gray-500",
                innerHTML: selected_menu.value?.description
              }, null, 8, _hoisted_213)
            ]),
            _createElementVNode("div", _hoisted_214, [
              _createElementVNode("div", _hoisted_215, [
                _hoisted_216,
                _hoisted_217,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("textarea", {
                    rows: "10",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", { 'border-red-200': _unref(text_error) }]),
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_isRef(text) ? (text).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(text)]
                  ])
                ]),
                (_unref(text_error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                      _hoisted_219,
                      _createElementVNode("div", null, _toDisplayString(_unref(text_error)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (step.value == 'input_media')
        ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
            _createElementVNode("div", _hoisted_221, [
              _createElementVNode("h3", _hoisted_222, _toDisplayString(selected_menu.value?.name), 1),
              _createElementVNode("p", {
                class: "text-gray-500",
                innerHTML: selected_menu.value?.description
              }, null, 8, _hoisted_223)
            ]),
            _createElementVNode("ul", _hoisted_224, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resource_urls.value, (resource_url) => {
                return (_openBlock(), _createElementBlock("li", { key: resource_url }, [
                  _createElementVNode("button", {
                    class: "relative bg-white shadow sm:rounded-lg",
                    onClick: ($event: any) => (removeResource(resource_url))
                  }, [
                    _createElementVNode("img", {
                      src: resource_url,
                      class: "w-full"
                    }, null, 8, _hoisted_226),
                    _createElementVNode("div", _hoisted_227, [
                      _createVNode(_component_fa, {
                        icon: "trash",
                        class: "text-white"
                      })
                    ])
                  ], 8, _hoisted_225)
                ]))
              }), 128)),
              _createElementVNode("li", {
                class: "relative p-4 bg-white",
                onDragenter: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["prevent"])),
                onDragover: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["prevent"])),
                onDrop: onImageDropped
              }, [
                _createElementVNode("div", {
                  onDrop: _withModifiers(onImageDropped, ["stop"]),
                  onClick: selectFile
                }, [
                  _createElementVNode("button", _hoisted_229, [
                    _createVNode(_component_fa, {
                      icon: "image",
                      class: "text-gray-600 text-lg"
                    }),
                    _hoisted_230
                  ])
                ], 40, _hoisted_228)
              ], 32)
            ]),
            _createElementVNode("input", {
              type: "file",
              ref_key: "upload_file",
              ref: upload_file,
              onChange: onUploadFileChanged,
              class: "hidden",
              accept: "image/*"
            }, null, 544)
          ]))
        : _createCommentVNode("", true),
      (step.value == 'confirm' || step.value == 'payment')
        ? (_openBlock(), _createElementBlock("div", _hoisted_231, [
            _createElementVNode("div", _hoisted_232, [
              _createElementVNode("div", _hoisted_233, [
                _createElementVNode("div", _hoisted_234, [
                  _createElementVNode("div", _hoisted_235, [
                    _createElementVNode("ul", _hoisted_236, [
                      _createElementVNode("li", _hoisted_237, [
                        _createElementVNode("div", _hoisted_238, [
                          _createElementVNode("div", _hoisted_239, [
                            _createElementVNode("div", _hoisted_240, [
                              _createElementVNode("h3", _hoisted_241, _toDisplayString(selected_menu.value?.name), 1),
                              _createElementVNode("p", {
                                class: "text-gray-500",
                                innerHTML: selected_menu.value?.description
                              }, null, 8, _hoisted_242)
                            ])
                          ]),
                          (_unref(family_name) && _unref(given_name))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                                _createElementVNode("div", _hoisted_244, [
                                  _createElementVNode("p", _hoisted_245, [
                                    _hoisted_246,
                                    _createTextVNode(_toDisplayString(`${_unref(family_name)} ${_unref(given_name)}`) + " ", 1),
                                    (_unref(family_name_kana) && _unref(given_name_kana))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_247, _toDisplayString(`${_unref(family_name_kana)} ${_unref(given_name_kana)}`), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(nickname))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_248, [
                                _createElementVNode("div", _hoisted_249, [
                                  _createElementVNode("p", _hoisted_250, [
                                    _hoisted_251,
                                    _createTextVNode(_toDisplayString(_unref(nickname)), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(buddist_name))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                                _createElementVNode("div", _hoisted_253, [
                                  _createElementVNode("p", _hoisted_254, [
                                    _hoisted_255,
                                    _createTextVNode(_toDisplayString(_unref(buddist_name)), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (date_of_birth.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_256, [
                                _createElementVNode("div", _hoisted_257, [
                                  _createElementVNode("p", _hoisted_258, [
                                    _hoisted_259,
                                    _createTextVNode(_toDisplayString(date_of_birth.value), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (date_of_dead.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_260, [
                                _createElementVNode("div", _hoisted_261, [
                                  _createElementVNode("p", _hoisted_262, [
                                    _hoisted_263,
                                    _createTextVNode(_toDisplayString(date_of_dead.value), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(age))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_264, [
                                _createElementVNode("div", _hoisted_265, [
                                  _createElementVNode("p", _hoisted_266, [
                                    _createElementVNode("label", _hoisted_267, _toDisplayString(age_of_dead_type.value == "kyonen" ? "享年" : "行年"), 1),
                                    _createTextVNode(_toDisplayString(_unref(age)), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(chief_mourner))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_268, [
                                _createElementVNode("div", _hoisted_269, [
                                  _createElementVNode("p", _hoisted_270, [
                                    _hoisted_271,
                                    _createTextVNode(_toDisplayString(_unref(chief_mourner)), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(birthplace))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_272, [
                                _createElementVNode("div", _hoisted_273, [
                                  _createElementVNode("p", _hoisted_274, [
                                    _hoisted_275,
                                    _createTextVNode(_toDisplayString(_unref(birthplace)), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(hobby))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_276, [
                                _createElementVNode("div", _hoisted_277, [
                                  _createElementVNode("p", _hoisted_278, [
                                    _hoisted_279,
                                    _createTextVNode(_toDisplayString(_unref(hobby)), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(school))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_280, [
                                _createElementVNode("div", _hoisted_281, [
                                  _createElementVNode("p", _hoisted_282, [
                                    _hoisted_283,
                                    _createTextVNode(_toDisplayString(_unref(school)), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(job))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_284, [
                                _createElementVNode("div", _hoisted_285, [
                                  _createElementVNode("p", _hoisted_286, [
                                    _hoisted_287,
                                    _createTextVNode(_toDisplayString(_unref(job)), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(conferment))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_288, [
                                _createElementVNode("div", _hoisted_289, [
                                  _createElementVNode("p", _hoisted_290, [
                                    _hoisted_291,
                                    _createTextVNode(_toDisplayString(_unref(conferment)), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  (_unref(text))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_292, [
                        _hoisted_293,
                        _createElementVNode("div", {
                          class: "flex flex-nowrap",
                          innerHTML: text_v.value
                        }, null, 8, _hoisted_294)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_295, [
                    _hoisted_296,
                    _createElementVNode("div", _hoisted_297, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resource_urls.value, (resource_url) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: resource_url,
                          class: "relative flex flex-col mx-2 w-64 justify-center items-center p-2 border border-gray-100 rounded-md"
                        }, [
                          _createElementVNode("img", {
                            src: resource_url,
                            class: "w-64"
                          }, null, 8, _hoisted_298)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("dl", _hoisted_299, [
                    _createElementVNode("div", _hoisted_300, [
                      _hoisted_301,
                      _createElementVNode("dd", _hoisted_302, "¥" + _toDisplayString(price.value), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_303, [
                  _createElementVNode("form", _hoisted_304, [
                    _createElementVNode("div", _hoisted_305, [
                      _createElementVNode("div", {
                        ref_key: "payment",
                        ref: payment
                      }, null, 512)
                    ])
                  ])
                ]),
                (!!error_message.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_306, _toDisplayString(error_message.value), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_307, [
        (step.value !== 'select_menu')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "mr-4 inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white",
              onClick: _withModifiers(previous, ["prevent"])
            }, " 戻る ", 8, _hoisted_308))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white",
          onClick: _withModifiers(next, ["prevent"])
        }, _toDisplayString(next_step_label.value), 9, _hoisted_309)
      ])
    ])
  ], 64))
}
}

})